/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CurriculumRequest { 
    highSchoolDegreeEarnedAt?: string;
    highSchoolDegreeMark?: number;
    matriculatedAt?: string;
    university?: string;
    universityProvinceCode?: string;
    degreeEarned?: boolean;
    degreeMark?: number;
    thesisTitle?: string;
    thesisSubject?: string;
    privateBankerRegisterSubscribedAt: string;
    regIsvapSubscription: boolean;
    regIsvapSubscriptionLastMaintainedAt?: string;
    efaCertification: boolean;
    efaCertificationLastMaintainedAt?: string;
    efpCertification: boolean;
    efpCertificationLastMaintainedAt?: string;
    eipCertification: boolean;
    notes?: string;
    imageUuid?: string;
    files?: Array<number>;
    lastOrInProgressQualification?: number;
    highSchoolFieldOfStudy?: number;
    highSchoolDegreeMarkBasis?: number;
    universityFieldOfStudy?: number;
    degreeMarkBasis?: number;
}

